import { render, staticRenderFns } from "./PesertaPelatihanPostTest.vue?vue&type=template&id=d756933a&scoped=true&"
import script from "./PesertaPelatihanPostTest.vue?vue&type=script&lang=js&"
export * from "./PesertaPelatihanPostTest.vue?vue&type=script&lang=js&"
import style0 from "./PesertaPelatihanPostTest.vue?vue&type=style&index=0&id=d756933a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d756933a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VChip,VCol,VIcon,VRow})
